export default [
  {
    path: "/workout/hub",
    name: "Workouts_v2",
    component: () => import(/* webpackChunkName: "workouts" */ "@/views/workouts/v2/trainingsHub.vue"),
    meta: {
      hideBottomNavigation: true,
      navbarTitle: "Trainingshub",
      hideAvatar: true,
      hideLogo: true,
      showBackButton: true,
      backTo: "/",
      addAppBarPadding: true,
      fullWidth: true,
      removeTopMarginNavbarTitle: true,
    },
  },
  {
    path: "/workout/mtt/:customerId/create",
    name: "MttWorkoutCreate",
    component: () => import(/* webpackChunkName: "workouts" */ "@/views/workouts/WorkoutCreateNew.vue"),
    meta: {
      rights: ["mtt_create_workouts"],
      hideBottomNavigation: true,
      fullWidth: true,
    },
  },
  {
    path: "/workout/mtt/:customerId/edit/:id",
    name: "MttWorkoutEdit",
    component: () => import(/* webpackChunkName: "workouts" */ "@/views/workouts/WorkoutCreateNew.vue"),
    meta: {
      rights: ["mtt_create_workouts"],
      hideBottomNavigation: true,
      fullWidth: true,
    },
  },
  {
    path: "/workout/summary",
    name: "WorkoutSummary",
    meta: {
      hideBottomNavigation: true,
      fullWidth: true,
    },
    component: () => import("@/views/workouts/v2/runWorkout/runWorkoutSummary.vue"),
  },
  {
    path: "/workout/run/split",
    name: "Workout_run",
    component: () => import(/* webpackChunkName: "workouts" */ "@/views/workouts/v2/runWorkout/runWorkout.vue"),
    meta: {
      navbarTitle: "Training",
      hideBottomNavigation: true,
      fullWidth: true,
    },
  },
]
